export default __webpack_public_path__ + "static/media/complete_group.5705094f.svg";